module.exports = __webpack_public_path__ + "img/disc.3c8db562.svg";